export const ReviewModel = {
  reviewerNote: '',
  status: 'done',
  reviewer: ''
}

export const ReviewForm = {
  data() {
    return {
      model: {
        ...ReviewModel
      }
    }
  }
}
